module.exports = __webpack_public_path__ + "img/riggott_accreditation_logos.f5bbc7a0.png";